export const updateUrlParams = (params, usePushState = false) => {
  const url = new URL(window.location.href)

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      url.searchParams.delete(key)
    } else {
      url.searchParams.set(key, value)
    }
  })

  const newUrl = url.toString()

  if (usePushState) {
    window.history.pushState({}, '', newUrl)
  } else {
    window.history.replaceState({}, '', newUrl)
  }

  return newUrl
}
